export var name = 'tournamentsInfo';
